import React from "react";
import { Alert } from "antd";
import ReactJson from '@microlink/react-json-view';

const OutputPreview = ({ resultPdf, resultJson, code, error }) => {
  return (
    <>
      {resultPdf && (
        <object
          data={resultPdf}
          type="application/pdf"
          style={{
            height: "500px",
            width: "100%",
            display: "block",
          }}
        >
          PDF embed not working
        </object>
      )}
      {resultJson && (
        <ReactJson
          src={resultJson}
          collapsed={true}
          style={{
            "text-align": "left",
          }}
        ></ReactJson>
      )}
      {error && (
        <Alert
          message={
            code === "ID"
              ? "Impossibile generare il documento PDF"
              : "Impossibile estrapolare i dati dal documento"
          }
          type="error"
          showIcon={true}
        ></Alert>
      )}
    </>
  );
};

export default OutputPreview;
